import React from 'react';
import _ from 'lodash';

import {
  useLookupOrderLazyQuery,
  useOrderLookupActivityLazyQuery
} from 'generated/graphql';

import * as types from './types';



export interface IOrderLite {
  id: string;
  orderNumber: string;
  customerFullName: string;
  customerEmail: string;
  lineItems: ILineItemLite[];
}

export interface ILineItemLite {
  id: string;
  productName: string;
  sku: string;
  quantity: number;
}

export interface IData {
  order: IOrderLite | null;
  logoUrl: string;
}

export function useQuery(storeId: string) {
  const [fnOrderLookupActivityQuery, orderLookupActivityQueryTuple] = useOrderLookupActivityLazyQuery({});

  const [fnQuery, tuple] = useLookupOrderLazyQuery({
    fetchPolicy: 'network-only'
  });



  React.useEffect(
    () => {
      if (storeId) {
        fnOrderLookupActivityQuery({
          variables: {
            storeId
          }
        });
      }
    },
    [
      storeId,
      fnOrderLookupActivityQuery
    ]
  );



  const wrappedQuery = React.useCallback(async (formState: types.IFormState) => {
    fnQuery({
      variables: {
        email: formState.customerEmail,
        orderNumber: formState.orderNumber
      }
    });
  }, [fnQuery]);



  const orderData = React.useMemo((): IOrderLite | null => {
    const salesOrder = tuple.data?.orderLite;

    return _.isNil(salesOrder) ? null : {
      id: salesOrder.id,
      orderNumber: salesOrder.orderNumber,
      customerEmail: salesOrder.customerEmail,
      customerFullName: salesOrder.customerFullName,

      lineItems: _.map(salesOrder.lineItems, (lineItem): ILineItemLite => ({
        id: lineItem.id,
        productName: lineItem.productName,
        sku: lineItem.sku,
        quantity: lineItem.quantity
      }))
    };
  }, [tuple]);

  const storeBrandData = React.useMemo(
    () => ({
      logoUrl: orderLookupActivityQueryTuple.data?.storeBrand?.logoUrl ?? ''
    }),
    [orderLookupActivityQueryTuple]
  );



  const wrappedTuple = React.useMemo(
    () => {
      const data: IData = {
        ...storeBrandData,
        order: orderData
      };

      return {
        ...tuple,
        loading: tuple.loading || orderLookupActivityQueryTuple.loading,
        data
      };
    },
    [
      tuple,
      orderData,
      storeBrandData,
      orderLookupActivityQueryTuple
    ]
  );



  return [
    wrappedQuery,
    wrappedTuple
  ] as const;
}
